import clsx from "clsx";
import styles from "./style.module.scss";

export default function LoadPostedItemSkeleton() {
  return (
    <div className={clsx(styles.loadItemContainer, "animate-pulse")}>
      <div className={styles.loadItemHeader}>
        <div className="flex items-center gap-2">
          <span className="h-4 w-20 bg-gray-300 rounded" />
          <span className="h-4 w-32 bg-gray-300 rounded" />
        </div>
        <div className="flex items-center gap-2">
          <span className="h-4 w-16 bg-gray-300 rounded" />
        </div>
      </div>

      <div className={styles.loadItemBody}>
        <div className="flex items-center gap-3 mb-3">
          <span className="h-5 w-40 bg-gray-300 rounded" />
          <span className="h-4 w-6 bg-gray-300 rounded" />
          <span className="h-5 w-40 bg-gray-300 rounded" />
        </div>

        <div className="grid grid-cols-3 desktop:grid-cols-6 gap-4">
          {[...Array(6)].map((_, index) => (
            <div key={index} className="flex flex-col gap-1">
              <span className="h-3 w-12 bg-gray-300 rounded" />
              <span className="h-4 w-16 bg-gray-300 rounded" />
            </div>
          ))}
        </div>
      </div>

      <div className={styles.loadItemFooter}>
        <div className="flex gap-2">
          <span className="h-8 w-20 bg-gray-300 rounded" />
          <span className="h-8 w-20 bg-gray-300 rounded" />
        </div>
      </div>
    </div>
  );
}
